"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
var react_1 = __importDefault(require("react"));
var Link_1 = __importDefault(require("../Link"));
var Grid_1 = __importDefault(require("../../basics/Grid"));
var typography_1 = require("../../typography");
var Button_1 = __importDefault(require("../../basics/Button"));
var HorizontalSpacer_1 = __importDefault(require("../../utils/HorizontalSpacer"));
var styles_1 = require("./styles");
var HS_1 = { small: 8, medium: 8, large: 8 };
var Pagination = function (_a) {
    var currentPage = _a.currentPage, numPages = _a.numPages, createUrlFn = _a.createUrlFn, commonProps = __rest(_a, ["currentPage", "numPages", "createUrlFn"]);
    if (numPages === 1) {
        return null;
    }
    return (react_1.default.createElement(Grid_1.default, __assign({ "data-component-name": "Pagination" }, commonProps),
        react_1.default.createElement(Grid_1.default.Cell, { span: "full" },
            react_1.default.createElement(styles_1.Wrapper, null,
                react_1.default.createElement(styles_1.Pages, null,
                    react_1.default.createElement(typography_1.Body, { level: "3", color: "GREY_70", inline: true }, "Jump to page:"),
                    react_1.default.createElement(HorizontalSpacer_1.default, { amount: HS_1 }, new Array(numPages).fill(null).map(function (_, i) {
                        if (i + 1 === currentPage) {
                            return (react_1.default.createElement(typography_1.Body, { key: i, level: "3", inline: true }, i + 1));
                        }
                        return (react_1.default.createElement(Link_1.default, { key: i, href: createUrlFn(i + 1) },
                            react_1.default.createElement(typography_1.Body, { level: "3", inline: true }, i + 1)));
                    }))),
                currentPage !== 1 && (react_1.default.createElement(Button_1.default, { href: createUrlFn(currentPage - 1), version: "outline" }, "Prev")),
                currentPage !== numPages && (react_1.default.createElement(Button_1.default, { href: createUrlFn(currentPage + 1), version: "outline" }, "Next"))))));
};
exports.Pagination = Pagination;
exports.default = exports.Pagination;
